import { Component, OnInit } from '@angular/core';
import { RoutineService} from '../../services/routine.service';


@Component({
  selector: 'app-routine',
  templateUrl: './routine.component.html',
  styleUrls: ['./routine.component.css']
})
export class RoutineComponent implements OnInit {
  selectedRoutine: number = 0;
  orderedList = -1;

  intervalType = ["dnů","týdnů","měsíců"];
  interval2Type = ["dne","týdne","měsíce"];


  newRoutine = {
    title: "",
    duration: 10,
    frequency: 1,
    timeInterval: 0,
    settings: 0,
    startDate: new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" + ("0" + (new Date().getDate() + 1)).slice(-2)
  }

  editedRoutine = {
    id: "",
    title: "",
    settings: 0,
    idUser: localStorage.getItem("idUser")
  };

  constructor(private routineService: RoutineService) { }

  ngOnInit() {
    this.routineService.getRoutines();
  }

  
  addRoutine(){
    this.routineService.addRoutine(this.newRoutine);
    this.newRoutine.title = "";
    this.newRoutine.duration = 10;
    this.newRoutine.frequency = 1;
    this.newRoutine.timeInterval = 0;
    this.newRoutine.settings = 0;
  }

  editRoutine(i){
    this.editedRoutine.id = this.routineService.routines[i].id;
    this.editedRoutine.title = this.routineService.routines[i].title;
    this.editedRoutine.settings = this.routineService.routines[i].settings;


    this.selectedRoutine = i;
  }

  updateRoutine(){
    this.routineService.updateRoutine(this.editedRoutine, this.selectedRoutine);
  }

  activityPlus(i,j){
    this.routineService.activityPlus(i,j);
  }
  activityNull(i,j){
    this.routineService.activityNull(i,j);
  }
  routineOlder(i){
    this.routineService.routineOlder(i);
  }
  routineNewer(i){
    this.routineService.routineNewer(i);
  }
  
  removeRoutine(i, id){
    this.routineService.removeRoutine(i, id);
    
  }

  dropSuccess(i){
    this.orderedList = -1;
    this.routineService.changeOrder(i+1);
  }

  dragStart(i){
    this.orderedList = i;
  }

  dragEnd(){
    this.orderedList = -1;
  }

  orderUp(i){
    this.routineService.orderUp(i);
  }
  orderDown(i){
    this.routineService.orderDown(i);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/routine/routine.component.ts